<!-- Impersonation banner -->
@if (authService.isImpersonating()) {
  <div class="hd-impersonation" role="status">
    <p class="min-w-0">
      Estás viendo <strong>{{ authService.getBusinessName() }}</strong> como administrador del sistema.
    </p>
    <button type="button" class="hd-impersonation__btn" (click)="stopImpersonation()">Volver al panel de administración</button>
  </div>
}

<header class="hd" [class.hd--offset]="authService.isImpersonating()">
  <div class="hd-bar">

    <!-- Sidebar toggle -->
    <button type="button" class="hd-icon-btn hd-menu-btn"
      [class.hidden]="isAdminPanel()"
      [class.hd-icon-btn--active]="mobileSidebarOpen"
      (click)="toggleSidebar()"
      [attr.aria-label]="mobileSidebarOpen ? 'Cerrar menú' : 'Abrir menú'"
      [attr.aria-expanded]="mobileSidebarOpen" aria-controls="sidebar-menu">
      @if (mobileSidebarOpen && !isLgUp()) {
        <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      } @else {
        <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h10.5m-10.5 5.25h16.5" />
        </svg>
      }
    </button>

    <!-- Business identity -->
    <div class="hd-identity">
      @if (isAdminPanel()) {
        <span class="hd-mark hd-mark--admin" aria-hidden="true">
          <svg class="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2L2 7l10 5 10-5-10-5z" /><path d="M2 17l10 5 10-5" /><path d="M2 12l10 5 10-5" />
          </svg>
        </span>
        <div class="min-w-0">
          <h2 class="hd-name">CitaLink Pro Admin</h2>
          <p class="hd-date">{{ today }}</p>
        </div>
      } @else if (isOwner()) {
        <a routerLink="/user/profile" class="hd-identity__link" aria-label="Ir al perfil para editar el negocio"
          title="Editar los datos del negocio">
          <span class="hd-mark" aria-hidden="true">{{ businessInitial() }}</span>
          <div class="min-w-0">
            <h2 class="hd-name">
              <span class="truncate">{{ businessName() }}</span>
              <svg class="hd-name__edit size-3.5" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125" />
              </svg>
            </h2>
            <p class="hd-date">{{ today }}</p>
          </div>
        </a>
      } @else {
        <span class="hd-mark" aria-hidden="true">{{ businessInitial() }}</span>
        <div class="min-w-0">
          <h2 class="hd-name"><span class="truncate">{{ businessName() }}</span></h2>
          <p class="hd-date">{{ today }}</p>
        </div>
      }
    </div>

    <div class="hd-actions">
      <!-- New: quick actions -->
      @if (!isAdminPanel() && !membershipService.isMembershipExpired()) {
        <div class="relative" (clickOutside)="quickActionsOpen = false">
          <button type="button" class="hd-new" (click)="$event.preventDefault(); toggleQuickActions()"
            aria-haspopup="menu" [attr.aria-expanded]="quickActionsOpen" aria-controls="hd-new-menu"
            aria-label="Nuevo: registrar una atención o una venta">
            <svg class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            <span class="hd-new__label">Nuevo</span>
            <svg class="hd-new__chevron size-3.5" [class.rotate-180]="quickActionsOpen" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
            </svg>
          </button>

          @if (quickActionsOpen) {
            <div id="hd-new-menu" class="hd-menu hd-menu--new" role="menu" aria-label="Nuevo">
              @if (canCreateEvent()) {
                <button type="button" class="hd-option" role="menuitem" (click)="openCreateEvent()">
                  <span class="hd-option__icon" aria-hidden="true">
                    <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6 1.5 1.5L16.5 12" />
                    </svg>
                  </span>
                  <span class="min-w-0">
                    <span class="hd-option__title">Registrar atención</span>
                    <span class="hd-option__hint">Un servicio que ya le hiciste a un cliente</span>
                  </span>
                </button>
              } @else {
                <div class="hd-option hd-option--disabled" role="menuitem" aria-disabled="true">
                  <span class="hd-option__icon" aria-hidden="true">
                    <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                    </svg>
                  </span>
                  <span class="min-w-0">
                    <span class="hd-option__title">Registrar atención</span>
                    <span class="hd-option__hint">Primero completa la configuración inicial del calendario</span>
                  </span>
                </div>
              }
              @if (canCreateSale()) {
                <button type="button" class="hd-option" role="menuitem" (click)="openRegisterSale()">
                  <span class="hd-option__icon" aria-hidden="true">
                    <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007Z" />
                    </svg>
                  </span>
                  <span class="min-w-0">
                    <span class="hd-option__title">Registrar venta</span>
                    <span class="hd-option__hint">Productos que vendiste en el local</span>
                  </span>
                </button>
              }
            </div>
          }
        </div>
      }

      <!-- Account -->
      <div class="relative" (clickOutside)="dropdownOpen = false">
        <button type="button" class="hd-user" (click)="toggleDropdown()"
          aria-haspopup="menu" [attr.aria-expanded]="dropdownOpen" aria-controls="hd-user-menu"
          [attr.aria-label]="'Tu cuenta: ' + (loggedUser()?.given_name || '')">
          <app-avatar class="hd-user__avatar"></app-avatar>
          <span class="hd-user__text">
            <span class="hd-user__name">{{ loggedUser()?.given_name }}</span>
            @if (authService.getDisplayRoleName(); as role) {
              <span class="hd-user__role">{{ role }}</span>
            }
          </span>
          <svg class="hd-user__chevron size-4" [class.rotate-180]="dropdownOpen" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
          </svg>
        </button>

        @if (dropdownOpen) {
          <div id="hd-user-menu" class="hd-menu hd-menu--user" role="menu" aria-label="Tu cuenta">
            <div class="hd-account">
              <p class="hd-account__name">{{ loggedUser()?.given_name }} {{ loggedUser()?.family_name }}</p>
              <p class="hd-account__email">{{ loggedUser()?.email }}</p>
            </div>

            @if (!authService.isSystemAdmin() || authService.isImpersonating()) {
              <div class="hd-group">
                <button type="button" class="hd-item" role="menuitem" (click)="routerProfile('/user/profile')">
                  <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.6" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                  Mi perfil
                </button>
                <button type="button" class="hd-item" role="menuitem" (click)="routerProfile('/settings')">
                  <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.6" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                  Configuración del negocio
                </button>
                @if (authService.isOwner() || authService.isImpersonating()) {
                  <button type="button" class="hd-item" role="menuitem" (click)="openWelcomeGuide()">
                    <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.6" stroke="currentColor" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    Guía de inicio
                  </button>
                }
                <a [routerLink]="['/user/support']" class="hd-item" role="menuitem" (click)="dropdownOpen = false">
                  <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.6" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
                  </svg>
                  Ayuda y soporte
                </a>
              </div>
            }

            <div class="hd-group">
              <button type="button" class="hd-item hd-item--toggle" role="menuitemcheckbox"
                [attr.aria-checked]="isDark()" (click)="toggleDarkMode()">
                <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.6" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
                </svg>
                <span class="flex-1 text-left">Modo oscuro</span>
                <span class="hd-switch" aria-hidden="true"><span class="hd-switch__knob"></span></span>
              </button>
            </div>

            <div class="hd-group">
              <button type="button" class="hd-item hd-item--danger" role="menuitem" (click)="signOut()">
                <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.6" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                </svg>
                Cerrar sesión
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</header>

<!-- Event creation modal -->
@if (!authService.isSystemAdmin() || authService.isImpersonating()) {
<app-modal [open]="openEventForm" [title]="'Registrar atención'" [size]="'2xl'" [bodyComponent]="EventAddForm"
  (confirm)="onEventModalConfirm($event)" [closeOnBackdrop]="true" [bodyInputs]="modalBodyInputs"
  (close)="openEventForm = false" confirmButtonText="Agendar" [isSaving]="savingEvent()">
</app-modal>
}

<!-- Product sales modal -->
@if (!authService.isSystemAdmin() || authService.isImpersonating()) {
<app-product-sales-modal [open]="salesModalOpen()" (close)="closeSalesModal()">
</app-product-sales-modal>
}
